import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { FormsModule } from "@angular/forms"
import { CcParamsGen } from "@app/cc-params-gen/cc-params-gen"
import { COMMON_IMPORTS } from "../common-imports"
import { flipYesNo } from "@app/helpers"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { YesNo } from "@app/utils/utils.component"
import { GenSelectComponent } from "@app/gen-inputs/gen-select/gen-select.component"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { CcParamsZonesComponent } from "@app/cc-params-zones/cc-params-zones.component"
import { CcReports } from "@app/cc-checkboxes/cc-checkboxes.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { ItaGetAuthComponent } from "@app/ita-get-auth/ita-get-auth.component"
import { ConfirmComponent } from "@app/confirm/confirm.component"

const hasFields = (cat: any) => cat.fields.length

@Component({
	selector: "app-cc-params-switch",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		FormsModule,
		YesNo,
		GenSelectComponent,
		GenInputComponent,
		CcParamsZonesComponent,
		CcReports,
		ModalWrapComponent,
		ItaGetAuthComponent,
		ConfirmComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./cc-params-switch.component.html",
})
export class CcParamsSwitchComponent extends CcParamsGen {
	modalProps: any = null
	saveObjName: string = "switches" //which part to save while updating
	cats: any[] = []
	search: string = ""
	shown: any[] = []

	ngOnInit() {
		this.cats = [
			{
				name: "followup_page",
				fields: [
					{
						name: "show_personal_memorandum",
						text: "show_personal_memorandum_text",
					},
					{
						name: "show_versions",
						text: "show_versions_text",
					},
					{
						name: "enable_past_followups_on_followup",
						text: "enable_past_followups_on_followup_text",
					},
					{
						name: "enable_group_attends_on_followup",
						text: "enable_group_attends_on_followup_text",
					},
				],
			},
			{
				name: "patient_files",
				fields: [
					{
						name: "id_number_on_patient_banner",
						text: "id_number_on_patient_banner_text",
					},
					{
						name: "show_patient_id",
						text: "show_patient_id_text",
					},
					{
						name: "calc_age_by_months",
						text: "calc_age_by_months_text",
					},
					{
						name: "mixed_list_sort_desc",
						text: "mixed_list_sort_desc_text",
					},
				],
			},
			{
				name: "zones",
				fields: [{ name: "zones" }],
			},
			{
				name: "calendar",
				fields: [
					{
						name: "enable_less_fus",
						text: "enable_less_fus_text",
					},

					{
						name: "no_saturday",
						text: "no_saturday_text",
					},
					{
						name: "short_meetings_calendar",
						text: "short_meetings_calendar_text",
					},
					{
						name: "color_by_meetingtype",
						text: "color_by_meetingtype_text",
					},
					{
						name: "notify_new_meeting",
						text: "notify_new_meeting_text",
					},
					{
						name: "login_to_weekly_view",
						text: "login_to_weekly_view_text",
					},
				],
			},
			{
				name: "finresources",
				fields: [
					{
						name: "invoice_per_followup",
						text: "invoice_per_followup_text",
					},
					{
						name: "enable_israel_invoice",
						text: "enable_israel_invoice_text",
					},
					{
						name: "debt_by_invoice_per_followup",
						text: "debt_by_invoice_per_followup_text",
					},
					{
						name: "show_manual_charge",
						text: "show_manual_charge_text",
					},
					{
						name: "send_original_to_user",
						text: "send_original_to_user_text",
					},
					{
						name: "is_selfinvoice",
						text: "is_selfinvoice_text",
					},
					{
						name: "show_payment_details",
						text: "show_payment_details_text",
					},
					{
						name: "show_email_in_pdf",
						text: "show_email_in_pdf_text",
					},
					{
						name: "show_future_meetings",
						text: "show_future_meetings_text",
					},

					{
						name: "budget_for_payors",
						text: "budget_for_payors_text",
					},

					{
						name: "prices_withoutvat_in_finresource",
						text: "prices_withoutvat_in_finresource_text",
					},
					{
						name: "show_therapist",
						text: "show_therapist_text",
						showFn: () => this.permsService.owner_has_users,
					},
					{
						name: "show_numbers_not_names_on_reports",
						text: "show_numbers_not_names_on_reports_text",
					},
					{
						name: "id_on_invoice",
						text: "id_on_invoice_text",
					},
				],
			},
			{
				name: "credit_clearance",
				fields: [
					{
						name: "MaxNumberOfPayments",
						text: "MaxNumberOfPayments_text",
						showFn: () => this.store.cc()?.credit_clearance,
					},
					{
						name: "enable_payment_terminal",
						text: "enable_payment_terminal_text",
						showFn: () => this.store.cc()?.credit_clearance,
					},
				],
			},

			{
				name: "expenses",
				fields: [
					{
						name: "expenses_by_created_at_default",
						text: "expenses_by_created_at_default_text",
					},
					{
						name: "expenses_by_former_month",
						text: "expenses_by_former_month_text",
					},
				],
			},
			{
				name: "reports",
				fields: [{ name: "reports" }],
			},
			{
				name: "documents",
				fields: [
					{
						name: "password_protected_documents",
						text: "password_protected_documents_text",
					},
					{
						name: "download_documents",
						text: "download_documents_text",
					},
					{
						name: "wide_logo",
						text: "wide_logo_text",
					},
					{
						name: "default_font_size",
						text: "default_font_size_text",
					},
				],
			},
			{
				name: "letters",
				fields: [
					{
						name: "default_medical_conf",
						text: "default_medical_conf_text",
					},
					{
						name: "default_font_for_documents",
						text: "default_font_for_documents_text",
					},
					{
						name: "default_font_size_for_documents",
						text: "default_font_size_for_documents",
					},
				],
			},

			{
				name: "language",
				fields: [
					{
						name: "enable_html_paste",
						text: "enable_html_paste_text",
					},
				],
			},
			{
				name: "search",
				fields: [
					{
						name: "show_non_active_on_search",
						text: "show_non_active_on_search_text",
					},
					{
						name: "show_search_by_phone",
						text: "show_search_by_phone_text",
					},
					{
						name: "search_by_tags_add_meeting",
						text: "search_by_tags_add_meeting_text",
						showFn: () => this.permsService.owner_has_users,
					},
				],
			},
			{
				name: "security",
				fields: [
					{
						name: "time_to_logout",
						text: "time_to_logout_text",
					},
				],
			},
			{
				name: "interface",
				fields: [
					{
						name: "show_insert_row",
						text: "show_insert_row_text",
					},
					{
						name: "colors_for_patients",
						text: "colors_for_patients_text",
					},
					{
						name: "pagination_in_big_tables",
						text: "pagination_in_big_tables_text",
					},
					{
						name: "notifications_upon_login",
						text: "notifications_upon_login_text",
					},
					{
						name: "buttons_with_labels",
						text: "buttons_with_labels_text",
					},
				],
			},
			{
				name: "special_preferences",
				fields: [
					{
						name: "send_tasks_notifications",
						text: "send_tasks_notifications_text",
						showFn: () => this.permsService.owner_has_users,
					},
					{
						name: "wa_app_installed",
						text: "wa_app_installed_text",
					},
				],
			},
		]
		this.handleSearch()
	}
	baseShown() {
		return [
			...this.cats.map((cat) => ({
				...cat,
				fields: cat.fields.filter((field) => !field?.showFn || field.showFn()),
			})),
		]
	}
	handleSearch() {
		const search = this.search.trim()
		if (!search) {
			this.shown = this.baseShown().filter(hasFields)
			return
		}
		this.shown = this.baseShown()
			.map((cat) => ({
				...cat,
				fields: cat.fields.filter((obj) => {
					const title = obj?.title || obj.name
					return (
						this.lang.getVal(title).includes(search) ||
						this.lang.getVal(obj?.text || "").includes(search)
					)
				}),
			}))
			.filter(hasFields)
	}
	clear() {
		this.search = ""
		this.handleSearch()
	}
	changeYesNo(name: string) {
		this.configcliniq[name] = flipYesNo(this.configcliniq[name])
		this.validateAndSave()
	}
	handleIPFChange() {
		this.changeYesNo("invoice_per_followup")
		if (this.needsIPFValidation()) {
			this.modalProps = { name: "confirm-ipf-change" }
		}
	}
	handleEIIChange() {
		this.changeYesNo("enable_israel_invoice")
		if (this.configcliniq.enable_israel_invoice == "yes") {
			this.modalProps = { name: "ita-get-auth" }
		}
	}
}
